import React, {Component} from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';

class TreeSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    }
  }

  propagateState = (node, checked) => {
    node.checked = checked;
    if (node.children) {
      node.children.forEach((child) => this.propagateState(child, checked));
    }
  }

  onChange = (currentNode, selectedNodes) => { //syncs this.props.data with the model in DropdownTreeSelect
    let path = currentNode._id.split('-');
    let curNode = this.props.data;
    path.forEach((node, i) => {
      curNode = curNode[node];
      curNode.checked = currentNode.checked && curNode.checked; //unchecks parent nodes when child node gets unchecked
      if (i < path.length - 1)
        curNode = curNode.children;
    })
    this.propagateState(curNode, currentNode.checked);
    this.props.setFieldValue('permissions', selectedNodes.map((node) => node.value));
  }

  onNodeToggle = (currentNode) => { //syncs this.props.data with the model in DropdownTreeSelect
    let path = currentNode._id.split('-');
    let curNode = this.props.data;
    path.forEach((node, i) => {
      curNode = curNode[node];
      if (i < path.length - 1)
        curNode = curNode.children;
    })
    curNode.expanded = currentNode.expanded;
  }

  render = () => {
    return (
      <div className="form-group">
        <label className="col-md-4 control-label">Permissions</label>
        <div className="col-md-8">
          <DropdownTreeSelect data={this.props.data} onChange={this.onChange} onNodeToggle={this.onNodeToggle} showPartiallySelected={true} />
        </div>
      </div>
    )
  }
}

export default TreeSelect;


// WEBPACK FOOTER //
// ./src/Components/Form/TreeSelect.js